import { InfoChartTerm } from 'components/QuickMenu/InfoDialog/InfoChart/InfoChart';

/**
 * The ID of the content type containing all contentful data.
 * Used to retrieve everything related to this content type via the API.
 */
export const CONTENTFUL_ROOT_CONTENT_TYPE = 'gdpr';

/**
 * the key of the app state session storage item
 */
export const SESSION_KEY_APP_STATE = 'appState';

/**
 * the key of the debug mode session storage item
 */
export const SESSION_KEY_DEBUG = 'debug';

/**
 * The route to the login view
 */
export const ROUTE_LOGIN = 'login';

/**
 * the route to the logout and redirect view
 */
export const ROUTE_LOGOUT = 'logout';

/**
 * The route to the home view
 */
export const ROUTE_HOME = 'home';
/**
 * The route to the contract wizard
 */
export const ROUTE_CONTRACT_WIZARD = 'contract-wizard';

/**
 * The route to the 'thank you' view after a successful contract signature
 */
export const ROUTE_THANKYOU = 'thank-you';

/**
 * Month of the year for date pickers
 */
export const MONTHS = [
	'january',
	'february',
	'march',
	'april',
	'may',
	'june',
	'july',
	'august',
	'september',
	'october',
	'november',
	'december',
];

/**
 * The available terms of the KPP insurance product
 */
export const KPP_TERMS: InfoChartTerm[] = [24, 36, 48, 60];
export const LAUFZEIT_Array = [12,24, 36, 48, 60, 72, 84, 96]
